import React from 'react';
import { TableCell, Chip, useTheme, alpha } from '@mui/material';
import { Worker } from '../../../models/worker';

const fmt = (t: string) => t.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (l) => l.toUpperCase());

/** Worker availability (Available / Unavailable) — its own column, distinct from status. */
const WorkerAvailabilityCell: React.FC<{ worker: Worker }> = ({ worker }) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    const availColors: Record<string, { bg: string; fg: string }> = {
        AVAILABLE: { bg: alpha(theme.palette.success.main, isDark ? 0.3 : 0.1), fg: theme.palette.success.main },
        UNAVAILABLE: { bg: alpha(theme.palette.error.main, isDark ? 0.3 : 0.1), fg: theme.palette.error.main },
    };
    const fallback = { bg: alpha(theme.palette.text.secondary, 0.1), fg: theme.palette.text.secondary };
    const ac = availColors[worker.workerAvailability] || fallback;

    return (
        <TableCell>
            <Chip
                label={fmt(worker.workerAvailability)}
                size="small"
                sx={{ backgroundColor: ac.bg, color: ac.fg, fontWeight: 600, height: 24, '& .MuiChip-label': { px: 1.5 } }}
            />
        </TableCell>
    );
};

export default WorkerAvailabilityCell;
